import { render, staticRenderFns } from "./WidgetApp.vue?vue&type=template&id=1d490852"
import script from "./WidgetApp.vue?vue&type=script&lang=js"
export * from "./WidgetApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports